import React, {useState, useRef, useEffect} from 'react';
import AnimatedWord from '../animations/AnimatedWord';
import AnimatedElement from '../animations/AnimatedElement';

function FeatureCard({ feature, delay }) {
  const { title, description, image, gradient } = feature; // Destructure feature object properties
  const localImage = `${process.env.PUBLIC_URL}/assets/features/${image}`;

  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef(null);


  const checkVisibility = () => {
    if (cardRef.current) {
      const rect = cardRef.current.getBoundingClientRect();
      const fullyVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
      const partiallyVisible = rect.top < window.innerHeight && rect.bottom >= 0;

      if (fullyVisible || partiallyVisible) {
        setIsVisible(true);
      }
    }
  };

   useEffect(() => {
      // Intersection Observer
    //   const observer = new IntersectionObserver(
    //     ([entry]) => {
    //       if (entry.isIntersecting) {
    //         setIsVisible(true);
    //       }
    //     },
    //     { threshold: 0.5 }
    //   );
  
    //   if (cardRef.current) {
    //     observer.observe(cardRef.current);
    //   }
  
      // Scroll Listener for Programmatic Scrolling
      window.addEventListener("scroll", checkVisibility);
  
      return () => {
        // if (cardRef.current) {
        //   observer.unobserve(cardRef.current);
        // }
        window.removeEventListener("scroll", checkVisibility);
      };
    }, []);


  return (
   <div ref={cardRef}>
   {isVisible && (
    <>
     <AnimatedElement 
   animationClass='animate-slide-fade-in' delay={delay}>
     <div
      className="relative rounded-3xl shadow-lg p-6 overflow-hidden"
      style={{
        background: `linear-gradient(to bottom right, ${gradient[0]}, ${gradient[1]})`,
      }}
    >
      {/* Image with opacity */}
      <div
        className="absolute top-0 left-0 right-0 bottom-0 opacity-50 overflow-hidden rounded-3xl"
        style={{
          backgroundImage: `url(${localImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          maskImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.7), transparent 90%)',
          WebkitMaskImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.7), transparent 90%)',
        }}
      />

      {/* Overlay layer for better text visibility */}
      <div
            className="absolute top-0 left-0 right-0 bottom-0 bg-black opacity-60 rounded-3xl"
          />

      {/* Content on top of the image */}
      <div className="relative z-10 flex flex-col h-full justify-end">
        <h2 className="text-xl font-semibold text-gray-300 mb-2">
            {title.split(' ').map((word, index) => (
                <AnimatedWord key={index} word={`${word} `} minimumDelay={delay} index={index} />
            ))}
        </h2>
        <p className="text-sm text-gray-300">{description}</p>
      </div>
    </div>
    </AnimatedElement>
    </>
   )}
   </div>
  );
}

export default FeatureCard;